module.exports = __webpack_public_path__ + "static/media/email.5c177c43.svg";